const state = {
    sidebar: {
        opened: true,
        withoutAnimation: false
    },
    device: 'desktop',  
    language: 'zh',
    size:  'medium'
}
const mutations = {
    TOGGLE_SIDEBAR: state => {
        state.sidebar.opened = !state.sidebar.opened
        state.sidebar.withoutAnimation = false
        if (state.sidebar.opened) {
        localStorage.setItem('sidebarStatus', 1)
        } else {
        localStorage.setItem('sidebarStatus', 0)
        }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
        localStorage.setItem('sidebarStatus', 0)
        state.sidebar.opened = false
        state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
        state.device = device
    },
    SET_LANGUAGE: (state, language) => {
        state.language = language
        localStorage.setItem('language', language)
    },
    SET_SIZE: (state, size) => {
        state.size = size
        localStorage.setItem('size', size)
    }
}
const actions = {
    toggleSideBar({ commit }) {
        commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
        commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
        commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
        commit('SET_LANGUAGE', language)
    },
    setSize({ commit }, size) {
        commit('SET_SIZE', size)
    }
}
  
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
  


// WEBPACK FOOTER //
// ./src/store/modules/app.js